(function($) {
  'use strict';

  // our variables
  let mainNavMobileBreakpoint = 1120, // breakpoint in pixels for main mobile menu
     utilityNavMobileBreakpoint = 767, // breakpoint for bringing in 'Utility' and 'User Login' navs into hamburger menu
     mobileMenuTogglesCreated = false, // a flag to either create button toggles or not
     secondaryNavsMobileDisplay = false, // a flag to check whether 'Utility' and 'User Login' are in mobile or desktop view
     mobileMenuTrigger = document.querySelector("button.js-mobile-nav-main-trigger"),
     utilityNav = document.querySelector('.nav--utility'),
     customerLoginNav = document.querySelector('.nav--customer-login'),
     navUtilCol = document.querySelector('.js-col-nav--util'),
     mobileMenuContainer = document.querySelector('.main-nav-wrapper nav');

  // only execute if there is an actual menu (i.e. ignore on Campaign Page types)
  if (mobileMenuTrigger) {

    /* For mobile breakpoints, we'll need to add button elements to act as toggles for hidden submenus.
    * These buttons will be removed when hitting our min desktop breakpoint of 1121px. */
    function createDropDownToggles() {

      let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      // only create toggle buttons when looking at mobile view
      if (windowWidth <= mainNavMobileBreakpoint) {

        if (mobileMenuTogglesCreated) {
          return; // exit if buttons already exist
        }

        let itemsWithSubmenus =  document.querySelectorAll('ul.nav--main a.has-submenu');

        // loop through all menu links that have submenus and insert a button element after them for our toggles
        itemsWithSubmenus.forEach((item, i)=> {

          let dropdownButton = document.createElement('button');
          dropdownButton.innerHTML = '<img src="/themes/custom/loomis/dist/images/icon-chevron-down-red.svg" />'
          item.parentNode.insertBefore(dropdownButton, item.nextSibling); //insert button after a tag
          dropdownButton.addEventListener('click', (e)=>{

            dropdownButton.classList.toggle('active'); // add active state to arrow buttons

            // check whether your the targeted ul submenu is showing or not
            if ($(dropdownButton).next().is(':visible')) {
              $(dropdownButton).next().slideUp('fast');
            } else {
              $(dropdownButton).next().slideDown('fast');
            }

          })
        })

        mobileMenuTogglesCreated = true;
      } else {

        let mobileNavToggleButtons = document.querySelectorAll('ul.nav--main button');

        // remove buttons if user switches back to desktop view from mobile
        if (mobileNavToggleButtons.length) {
          mobileNavToggleButtons.forEach((button, i)=>{
            button.remove();
          })

          mobileMenuTogglesCreated = false;
        }

      }
    }

    createDropDownToggles();
    window.addEventListener('resize', Drupal.debounce(createDropDownToggles, 250));

    /* A simple function to move our secondary navs inside our hamburger menu or back to the top utility nav bar.
    * Gets called form inside initMainMenu() */
    function moveSecondaryNavs() {

      let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      // Move Utility and Customer Login navs inside mobile menu only at or below 767px
      if (windowWidth <= utilityNavMobileBreakpoint && secondaryNavsMobileDisplay === false ) {

        mobileMenuContainer.appendChild(utilityNav);
        mobileMenuContainer.appendChild(customerLoginNav);

        secondaryNavsMobileDisplay = true;

        return;

      }

      // Move Utility and Customer Login navs back to their original location
      if (windowWidth > utilityNavMobileBreakpoint && secondaryNavsMobileDisplay === true ) {
        navUtilCol.appendChild(utilityNav);
        navUtilCol.appendChild(customerLoginNav);

        secondaryNavsMobileDisplay = false;

        return;
      }
    }

    /* Init superfish hover submenus only on desktop resolutions. We'll also wrap secondary navs like 'Utility' and
    * our 'User Login' nav into our mobile menu but ONLY at a resolution of less or equal to 767px (phone-lg) to use our
    * space in the best way possible and not have a 'Newsletter' toggle link by itself on medium to large screen sizes.
    * ~ JL */
    function initMainMenu() {

      let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

      // Destroy superfish menu dropdowns at and below 1022px;
      if( windowWidth <= mainNavMobileBreakpoint) {
        $(".js-nav--main").superfish('destroy').removeClass('sf-menu'); // kill superfish hover dropdowns
        moveSecondaryNavs(); // check to see if 'User Login' and 'Utility' navs need to be moved

      // Init/re-init Superfish dropdowns
      } else {

        $(".js-nav--main").addClass('sf-menu').superfish({
          cssArrows: false,
          delay: 300,
          speed: 'fast',
          speedOut: 0,
          disableHI: true,
          hoverClass: 'sf-hover',
        });

        moveSecondaryNavs();
      }
    }

    initMainMenu();
    window.addEventListener('resize', Drupal.debounce(initMainMenu, 250));

    // Hamburger menu trigger
    // =============================================
    function toggleMobileMenu(e) {
      let hamIcon = document.querySelector('button.js-mobile-nav-main-trigger .ham-icon');
        hamIcon.classList.toggle('active');
        document.querySelector('body').classList.toggle('mobile-menu-open');
    }

    // check for possible campaign page (no mobile menu) to prevent undefined error
    mobileMenuTrigger.addEventListener('click', toggleMobileMenu);

    $(document).on('click', function(e) {
      if ($('body').hasClass('mobile-menu-open') &&
        !$('.js-mobile-nav-main-trigger').is(e.target) &&
        !$(".js-mobile-nav-main-trigger").find("*").is(e.target) &&
        !$(e.target).closest('.main-nav-wrapper > nav').length) {
        $('button.js-mobile-nav-main-trigger .ham-icon').removeClass('active');
        $('body').removeClass('mobile-menu-open');
      }
    });

  } // end of if statement for mobile menu JS

})(jQuery);
